<template>
  <div class="spinner"></div>
</template>

<script>

export default {
  name: "Spinner",
};

</script>

<style scoped>

.spinner {
  display: flex;
  justify-content: center;
}

.spinner::after {
  content: "";
  width: 1.5rem;
  height: 1.5rem;
  border: 0.3rem solid #dddddd;
  border-top-color: #0077FF;
  border-radius: 50%;
  animation: spinner 1s ease infinite;
}

@keyframes spinner {
  to {
    transform: rotate(1turn);
  }
}

</style>